import { chain, createSwitcherGroup } from '@leprecoins/effector';
import { createEvent, sample } from 'effector';
import { combineEvents, not, or } from 'patronum';
import { authModel, USER_ROLES } from 'shared/api';
import { breakpoints } from 'shared/lib';
import { router } from 'shared/routing';

const createLayoutSwitcher = createSwitcherGroup();

const navbarSwitcher = createLayoutSwitcher();

const asideSwitcher = createLayoutSwitcher();

const $modalsOpened = or(navbarSwitcher.$active, asideSwitcher.$active);

const closeModals = createEvent();

const setup = createEvent();

sample({
	clock: closeModals,
	target: [navbarSwitcher.disable, asideSwitcher.disable],
});

chain(router.$path, navbarSwitcher.disable);

sample({
	clock: router.$path,
	filter: not(breakpoints.lg),
	target: asideSwitcher.disable,
});

// TODO: replace with admin group route open
sample({
	clock: combineEvents([setup, authModel.authorized]),
	source: {
		lg: breakpoints.lg,
		role: authModel.$role,
	},
	filter: ({ lg, role }) => lg && (role === USER_ROLES.god || role === USER_ROLES.admin),
	target: asideSwitcher.enable,
});

export const adminLayoutModel = {
	navbarSwitcher,
	asideSwitcher,
	closeModals,
	$modalsOpened,
	setup,
};
